import axios from "axios";

export const lookupTripTypes = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/triptypes`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
